<app-user-header class="d-md-none"></app-user-header> 



<div class="wrapperi"> 
  
  
    <div class="col-12">

        <div class="col-12 row m-0">
            <div class="col-12 ps-3">
                <h3 class="mt-4 mb-3">Maksuhistoria</h3>
                
            </div>
            <div class="col-12 ps-3 pe-3 pb-4">
                <div class="formed-shadow pt-0 ps-2 pe-2 pb-4">
            <div class="col-12 col-md-12 input-cover p-4">
              <div class="col-12 d-flex">
                  <div class="form-floating mb-2  me-2">
                      <input type="date" placeholder="Alku" id="start" class="form-control" required>
                      <label for="start">Alku</label>
                  </div>
                  <div class="form-floating mb-2 me-2 p-0">
                      <input type="date" placeholder="Loppu" id="end" class="form-control" required>
                      <label for="end">Loppu</label>
                  </div>
                  <div class="mt-3">
                    <button class="btn btn-formed-main-blue" (click)="searchByDates()">Hae</button>

                  </div>
              </div>
              <div class="table-responsive" *ngIf="billings && billings.length > 0;else no_answers_content">
                  <table class="table align-items-center table-flush">
                      <thead class="thead-light">
                          <tr>
                              <th>Päivämäärä</th>
                              <th>Nimike</th>
                              <th>Kustannuspaikka</th>
                              <th>Yksikköhinta</th>
                              <th>Kappalemäärä</th>
                              <th>Summa (alv 0%)</th>
                          </tr>
                      </thead>
                      <tbody class="tbody-light">
                          <tr *ngFor="let data of billings">
                              <td>{{data.createdDate | formateDate}}</td>
                              <td>{{data.name}}</td>
                              <td>
                                <span *ngIf="!data.cost_center">
                                
                                </span>
                                <span *ngIf="data.cost_center">
                                    {{data.cost_center}}
                                </span>
                                </td>
                              <td>
                                <span *ngIf="!data.unit_price">
                                0
                                </span>
                                <span *ngIf="data.unit_price">
                                    {{data.unit_price}}
                                </span>
                                </td>
                              <td>
                                <span *ngIf="!data.qty">
                                    0
                                    </span>
                                    <span *ngIf="data.qty">
                                        {{data.qty}}
                                    </span>
                                </td>
                              <td>{{data.price}}€</td>
                          </tr>
                      </tbody>
                      <tbody class="tbody-light">
                          <tr>
                              <td class="bold">Yhteensä (alv 0%):</td>
                              <td>{{finalSum}}€</td>
                              <td></td>
                          </tr>
                      </tbody>
      
                  </table>
              </div>
              <ng-template #no_answers_content>
                  <div class="col-12 row m-0">
                      <div class="col-3"></div>
                      <div class="col-12 col-md-6">
                          <div class="alert alert-warning">
                              <p class="normal-text text-center">Et ole tehnyt vielä mitään josta kertyy kuluja.</p>
                          </div>
                      </div>
                      <div class="col-3"></div>
                  </div>
              </ng-template>
              </div>
      
        </div>
      </div>
</div>
    </div>
  </div>



